// Copyright (C) 2012-present, The Authors. This program is free software: you can redistribute it and/or  modify it under the terms of the GNU Affero General Public License, version 3, as published by the Free Software Foundation. This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU Affero General Public License for more details. You should have received a copy of the GNU Affero General Public License along with this program.  If not, see <http://www.gnu.org/licenses/>.

import { Box, Link } from 'theme-ui'

const DanskFooter = () => {
  return (
    <Box 
      sx={{ 
        mt: [4, null, 5],
        backgroundColor: '#f5f5f5',
        padding: [3, null, 4],
        borderRadius: 2,
        border: '1px solid #e0e0e0',
        fontSize: [1, null, 2],
        lineHeight: 1.5
      }}
    >
      <Box sx={{ mb: [2, null, 3] }}>
        Polis-modellen er udviklet af <a 
          href="https://compdemocracy.org/" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{ color: '#0066cc', textDecoration: 'underline' }}
        >
          The Computational Democracy Project
        </a>
      </Box>
      <Box sx={{ mb: [2, null, 3] }}>
        Hjemmesiden og servere ejes af Dansk Kommunikation ApS.
      </Box>
      <Box>
        Modellen kan lånes, hvis vi synes, at det tjener et almennyttigt formål. Kontakt: Dansk Kommunikation dakom@dakom.dk
      </Box>
        <Box sx={{ mb: [2, null, 3] }}>
            © Dansk Kommunikation - 
          <a href="https://dansksamtale.dk/privacy">Privatlivspolitik</a>
        </Box>
    </Box>
  )
}

export default DanskFooter
